export const LABOR_MULTIPLIERS = {
  scrap: 2,
  fieldCaught: 3,
  reworkDown: 2.5,
  reworkStation: 1,
  cosmetic: 0.3,
};

export function reworkLaborCost({ laborRate, reworkMinutes }) {
  return (laborRate / 60) * reworkMinutes;
}

// Base per-occurrence cost for a failure mode given a specific economics
// profile. Callers can pass step-level overrides merged into plant economics
// (e.g. per-step BOM cost) before invoking this.
export function costPerOccurrence(failureMode, economics) {
  const labor = reworkLaborCost(economics);
  const detectRate = (economics.detectProbability || 0) / 100;

  switch (failureMode) {
    case 'scrap':
      return economics.bomCost + labor * LABOR_MULTIPLIERS.scrap;
    case 'field':
      return (
        (1 - detectRate) * economics.warrantyCost +
        detectRate * labor * LABOR_MULTIPLIERS.fieldCaught
      );
    case 'rework-down':
      return labor * LABOR_MULTIPLIERS.reworkDown;
    case 'rework-station':
      return labor * LABOR_MULTIPLIERS.reworkStation;
    case 'cosmetic':
      return labor * LABOR_MULTIPLIERS.cosmetic;
    case 'none':
    default:
      return 0;
  }
}

// Scale a window total to a yearly figure using the customer's operating
// calendar. 250 = typical 5-day × 50-week. 365 = continuous 24/7.
export function annualize(windowTotal, windowDays, operatingDaysPerYear) {
  if (!windowDays || windowDays <= 0) return windowTotal;
  return windowTotal * ((operatingDaysPerYear || 250) / windowDays);
}

export function severityDistribution(steps, stepModes, defaultMode) {
  const counts = {};
  for (const step of steps) {
    const mode = stepModes[step.index] || defaultMode;
    counts[mode] = (counts[mode] || 0) + 1;
  }
  return counts;
}
